import config from "../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "./utils";
import { sectionDraftsApi } from "./sectionDrafts";
import { clauseDraftsApi } from "./clauseDrafts";
import { documentLocksApi } from "./documentLocks";
import type { DraftsDeleteResponse } from "../../../api/src/documents/drafts/delete";
import {
  DraftsSyncResponse,
  DraftsSyncRequest,
} from "../../../api/src/documents/drafts/sync";

export const draftsSyncApi = createApi({
  reducerPath: "draftsSyncApi",
  baseQuery: fetchBaseQuery({ baseUrl: config.api, prepareHeaders }),
  endpoints: (builder) => ({
    syncDrafts: builder.mutation<
      DraftsSyncResponse,
      { documentId: string; data: DraftsSyncRequest }
    >({
      query: ({ documentId, data }) => ({
        url: `documents/${documentId}/drafts/sync`,
        method: "POST",
        body: data,
      }),
    }),
    deleteDrafts: builder.mutation<
      DraftsDeleteResponse,
      { documentId: string }
    >({
      query: ({ documentId }) => ({
        url: `documents/${documentId}/drafts/delete`,
        method: "DELETE",
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } finally {
          // Invalidate corresponding tags in sibling API slices so their caches refetch
          dispatch(clauseDraftsApi.util.invalidateTags(["clauseDrafts"]));
          dispatch(sectionDraftsApi.util.invalidateTags(["sectionDrafts"]));
          // Invalidate document locks to exit edit mode
          dispatch(documentLocksApi.util.invalidateTags(["documentLocks"]));
        }
      },
    }),
  }),
});

export const { useSyncDraftsMutation, useDeleteDraftsMutation } = draftsSyncApi;
